export abstract class BaseDatepickerService {
  abstract setLocale(): void;
  abstract getLocale(): string;
  abstract getDateFormat(): string;
}
